export const Trans_mex = {
	'anticipo': 'Gastos de producción',
	'anticipos': 'Gastos de producción',
	'legalizado parcial': 'Comprobación de gasto parcial',
	'legalizado': 'Comprobación de gasto',
	'detalle anticipos': 'Detalle gastos de producción',
	'solicitud de anticipo': 'Solicitud gastos de producción',
	'crear anticipo para un proveedor': 'Crear gasto de producción para un proveedor',
	'filtrar anticipos': 'Filtrar gastos de producción',
	'rechazar anticipo': 'Rechazar gasto de producción',
	'enviar anticipo': 'Enviar gasto de producción',
	'eliminar anticipo': 'Eliminar gasto de producción',
	'legalizar anticipo': 'Comprobar gasto de producción',
	'legalizada': 'comprobada',
	'legalizar': 'comprobar',
	'fecha legalizado desde': 'fecha comprobado desde',
	'fecha legalizado hasta': 'fecha comprobado hasta',
	'recoger' : 'pick up'
}